/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cache = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepKernel = require('deep-kernel');

var _deepKernel2 = _interopRequireDefault(_deepKernel);

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _Exception = require('./Exception/Exception');

var _SharedCache = require('./SharedCache');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Cache manager
 */
let Cache = exports.Cache = function (_Kernel$ContainerAwar) {
  _inherits(Cache, _Kernel$ContainerAwar);

  /**
   * @param {AbstractDriver} driver
   * @param {AbstractDriver} systemDriver
   */
  function Cache() {
    let driver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let systemDriver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Cache);

    var _this = _possibleConstructorReturn(this, (Cache.__proto__ || Object.getPrototypeOf(Cache)).call(this));

    _this._driver = driver;
    _this._systemDriver = systemDriver;
    return _this;
  }

  /**
   * @param {String} name
   * @param {*} args
   * @returns {AbstractDriver}
   */


  _createClass(Cache, [{
    key: 'boot',


    /**
     * Booting a certain service
     *
     * @param {Kernel} kernel
     * @param {Function} callback
     */
    value: function boot(kernel, callback) {
      this._driver = this._createCacheDriver(kernel);
      this._systemDriver = this._createCacheDriver(kernel);

      let sharedCacheDriver = kernel.isFrontend ? Cache.createDriver('cloud-front', this) : Cache.createDriver('s3fs', this);

      this._shared = new _SharedCache.SharedCache(sharedCacheDriver);

      [this._driver, this._systemDriver, sharedCacheDriver].forEach(driver => {
        driver.buildId = kernel.buildId;
      });

      this._systemDriver.namespace = Cache.SYSTEM_NAMESPACE;

      callback();
    }

    /**
     * @returns {SharedCache|*}
     */

  }, {
    key: '_createCacheDriver',


    /**
     * @todo: remove in memory fallback for backend?
     *
     * @param {Kernel} kernel
     * @returns {AbstractDriver}
     * @private
     */
    value: function _createCacheDriver(kernel) {
      return kernel.isFrontend ? Cache.createDriver('local-storage') : kernel.config.cacheDsn ? Cache.createDriver('redis', kernel.config.cacheDsn) : Cache.createDriver('memory');
    }

    /**
     * @param {AbstractDriver|*} target
     * @param {*} args
     * @returns {*}
     */

  }, {
    key: 'apply',
    value: function apply(target) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return target.apply(undefined, args);
    }

    /**
     * DO NOT REMOVE THIS!
     * It's used while kernel boot
     *
     * @returns {Object}
     */

  }, {
    key: 'shared',
    get: function get() {
      return this._shared;
    }

    /**
     * @returns {AbstractDriver|*}
     */

  }, {
    key: 'system',
    get: function get() {
      return this._systemDriver || this._driver;
    }
  }, {
    key: 'service',
    get: function get() {
      return new _deepCore2.default.Generic.MethodsProxy(this).proxyOverride(this._driver, 'has', 'get', 'set', 'invalidate', 'flush', 'type');
    }

    /**
     * @param {AbstractDriver} driver
     */

  }, {
    key: 'driver',
    set: function set(driver) {
      this._driver = driver;
    }

    /**
     * @returns {AbstractDriver}
     */
    ,
    get: function get() {
      return this._driver;
    }

    /**
     * @param {AbstractDriver} driver
     */

  }, {
    key: 'systemDriver',
    set: function set(driver) {
      this._systemDriver = driver;
    }

    /**
     * @returns {AbstractDriver}
     */
    ,
    get: function get() {
      return this._systemDriver;
    }

    /**
     * @returns {String}
     */

  }], [{
    key: 'createDriver',
    value: function createDriver(name) {
      let DriverPrototype = null;

      switch (name) {
        case 'memory':
          DriverPrototype = require('./Driver/InMemoryDriver').InMemoryDriver;
          break;
        case 'redis':
          DriverPrototype = require('./Driver/RedisDriver').RedisDriver;
          break;
        case 'local-storage':
          DriverPrototype = require('./Driver/LocalStorageDriver').LocalStorageDriver;

          // fallback to in-memory driver if localStorage is not available
          if (!DriverPrototype.isAvailable()) {
            DriverPrototype = require('./Driver/InMemoryDriver').InMemoryDriver;
          }
          break;
        case 's3fs':
          DriverPrototype = require('./Driver/S3FSDriver').S3FSDriver;
          break;
        case 'cloud-front':
          DriverPrototype = require('./Driver/CloudFrontDriver').CloudFrontDriver;
          break;
        default:
          throw new _Exception.Exception(`Missing driver ${name}`);
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return new (Function.prototype.bind.apply(DriverPrototype, [null].concat(args)))();
    }
  }, {
    key: 'SYSTEM_NAMESPACE',
    get: function get() {
      return 'system';
    }
  }]);

  return Cache;
}(_deepKernel2.default.ContainerAware);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Cache.js
// module id = 346
// module chunks = 0